import { jsx } from 'react/jsx-runtime';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import './alert.js';
import '@radix-ui/react-avatar';
import './badge.js';
import 'lucide-react';
import 'react';
import 'react-day-picker';
import './button.js';
import './chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import './radio-group.js';
import '@radix-ui/react-select';
import './time-input.js';
import '@radix-ui/react-separator';
import './sidebar.js';
import 'react-toastify';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../page-layout/FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

function Switch({ className, ...props }) {
    return (jsx(SwitchPrimitive.Root, { "data-slot": "switch", className: cn('peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-input focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-input/80 inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50', className), ...props, children: jsx(SwitchPrimitive.Thumb, { "data-slot": "switch-thumb", className: cn('bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0') }) }));
}

export { Switch };
//# sourceMappingURL=switch.js.map
